import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";

import { MSpinner } from "components/Shared";
import TextBlock from "components/Shared/TextBlock";
import {
  setMultiFactorVerifyStart,
} from "requests/profile";
import MDialog, { ACTION_CLOSE } from "components/Shared/MDialog.tsx";

const SelectTwoFactor = (props) => {
  const mounted = useRef(true);
  // Dropdown options for multi-factor selection
  const [multiFactorOptions, setMultiFactorOptions] = useState([]);
  // 2fa method selected by the user
  const [mutliFactorMethodSelection, setMutliFactorMethodSelection] = useState("");

  const {
    username,
    userLogout,
    multiFactorMethods,
    authenticationToken,
    multiFactorVerifyStartResponse,
    setMultiFactorVerifyStartResponse,
    verifyInitiated,
    setVerifyInitiated,
  } = props;

  useEffect(() => {
    if (multiFactorMethods.length && !multiFactorOptions.length) {
      setMultiFactorOptions(getOptions());
      setMutliFactorMethodSelection(getOptions()[0].value);
    } else if (multiFactorMethods.length === 1 && !verifyInitiated) {
      setVerifyInitiated(true);
      submitMultiFactorMethod(multiFactorMethods[0]);
    } else if (multiFactorOptions.length && multiFactorOptions.some(s => s.preferred) && !verifyInitiated) {
      setVerifyInitiated(true);
      submitMultiFactorMethod(multiFactorOptions.filter(s => s.preferred)[0].value);
    }
  });

  let submitMultiFactorMethod = (initVal) => {
    setMultiFactorVerifyStartResponse({ data: null, isFetching: true });
    setMultiFactorVerifyStart({
      multiFactorMethod: initVal ? initVal : mutliFactorMethodSelection,
      token: authenticationToken,
      username: username
    }, (s) => setMultiFactorVerifyStartResponse({ data: s, isFetching: false }), mounted);
  };

  let onChange = (option) => {
    setMutliFactorMethodSelection(option.target.value);
  };

  let submitActions = () => {
    let actions = [];
    actions.push({ code: ACTION_CLOSE, onClick: () => userLogout(), helpText: "Logout" });
    return actions;
  };

  let getOptions = () => {
    return multiFactorMethods.map(s => {
      switch (s) {
        case "Email a verification code":
          return { label: "Email A Verification Code", value: s, preferred: false };
        case "Text a verification code to my phone":
          return { label: "Text A Verification Code", value: s, preferred: true };
        case "Code is always 123456":
          return { label: s, value: s, preferred: false };
        default:
          break;
      }
    });
  };

  return (
    <MDialog
      id={"dialog-select-auth-method"}
      visible={true}
      actions={submitActions()}
      title={!multiFactorVerifyStartResponse.isFetching
        ? "Verification Method"
        : "Verifying"
      }
      width={400}>
      <>
        {(!multiFactorMethods.length) &&
          <div className="two-factor-spinner">
            <TextBlock field={`You have no Verification Methods available. Please contact Support.`} />
          </div>}
        {(multiFactorVerifyStartResponse.isFetching) &&
          <div className="two-factor-spinner">
            <TextBlock field={`Processing...`} />
            <MSpinner />
          </div>}
        {multiFactorMethods.length && !multiFactorVerifyStartResponse.isFetching &&
          <>
            <FormControl component="fieldset">
              <RadioGroup aria-label="method" name="method1" value={mutliFactorMethodSelection} onChange={(curr) => onChange(curr)}>
                {multiFactorOptions.map(s => (<FormControlLabel key={s.value} value={s.value} control={<Radio />} label={s.label} />))}
              </RadioGroup>
            </FormControl>
            <hr />
            <div className="verify-controls">
              <Button onClick={() => submitMultiFactorMethod()}><div>Continue</div></Button>
            </div>
          </>}
      </>
    </MDialog>
  );
};

SelectTwoFactor.propTypes = {
  username: PropTypes.string,
  userLogout: PropTypes.func,
  multiFactorMethods: PropTypes.array,
  authenticationToken: PropTypes.string,
  multiFactorVerifyStartResponse: PropTypes.object,
  setMultiFactorVerifyStartResponse: PropTypes.func,
  verifyInitiated: PropTypes.bool,
  setVerifyInitiated: PropTypes.func,
};

export default SelectTwoFactor;